module.exports = __webpack_public_path__ + "media/common/images/badges/active/jizda_pod_plynem-5793181656d3fd98d2e662b3846b7de1.svg";